import { Theme } from '@/shared/components/CColor.vue';
import { Theme as ButtonTheme } from '@/shared/components/buttons/CButton.vue';
import OrderStatus from '../constants/OrderStatus';
import PriceApprovalStatus from '../constants/PriceApprovalStatus';

export function getOrderStatusButtonTheme(status: OrderStatus, hasSignature?: boolean): ButtonTheme {
  if (status === OrderStatus.APPROVED && hasSignature) return 'light-success';
  if (status === OrderStatus.REFUSED) return 'light-danger';
  return 'normal-secondary';
}

export function getPriceApprovalStatusButtonTheme(status: PriceApprovalStatus): ButtonTheme {
  switch (status) {
    case PriceApprovalStatus.APPROVED:
      return 'light-success';
    case PriceApprovalStatus.REFUSED:
      return 'light-danger';
  }
}

export function getPriceApprovalIconTheme(status: PriceApprovalStatus): Theme {
  switch (status) {
    case PriceApprovalStatus.NOT_GIVEN:
      return 'neutral';
    case PriceApprovalStatus.APPROVED:
      return 'success';
    case PriceApprovalStatus.REFUSED:
      return 'danger';
  }
}